import { useEffect, useState } from 'react';

import { isIphone } from '@/components/PdfReader/PdfNotes/SelectionTooltip';

export const useKeyboardHeight = () => {
  const [keyboardHeight, setKeyboardHeight] = useState(0);

  useEffect(() => {
    const onResize = () => {
      if (window.visualViewport) {
        const heightDiff = window.innerHeight - window.visualViewport.height;
        setKeyboardHeight(
          heightDiff > 100 ? heightDiff - (isIphone() ? 50 : 0) : 0,
        );
      }
    };

    window.visualViewport?.addEventListener('resize', onResize);
    return () => {
      window.visualViewport?.removeEventListener('resize', onResize);
    };
  }, []);

  return keyboardHeight;
};
